var style = {"z-form-field-wrap":"z-form-field-wrap","z-form-field-wrap__group":"z-form-field-wrap__group","z-form-field-wrap__title":"z-form-field-wrap__title","z-form-field-wrap__content":"z-form-field-wrap__content","z-form-field-wrap--horizonal":"z-form-field-wrap--horizonal","z-form-field-wrap--horizontal":"z-form-field-wrap--horizontal"};

export { style as default };
//# sourceMappingURL=FormFieldWrap.module.scss.js.map
